import React from "react";

import { FormControl, MenuItem, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

export const FormInputDropdown = ({ name, control, label, options }) => {
  const generateSingleOptions = () => {
    return options.map((option) => {
      return (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      );
    });
  };
  return (
    <FormControl size="small" sx={{ width: "100%" }}>
      <Controller
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            select
            onChange={onChange}
            value={value}
            label={label}
            helperText={error ? error.message : null}
            error={!!error}
          >
            {generateSingleOptions()}
          </TextField>
        )}
        control={control}
        name={name}
      />
    </FormControl>
  );
};
